var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkPaperclip = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8CBAC7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.737 18.79-3.052 3.052a3.24 3.24 0 0 1-4.579 0 3.216 3.216 0 0 1-.948-2.29 3.217 3.217 0 0 1 .948-2.289l3.053-3.052a1.08 1.08 0 0 0-1.527-1.526L6.58 15.737A5.36 5.36 0 0 0 5 19.553a5.36 5.36 0 0 0 1.58 3.816 5.38 5.38 0 0 0 3.816 1.578 5.379 5.379 0 0 0 3.815-1.578l3.052-3.053a1.08 1.08 0 0 0-1.526-1.526zM24.948 10.396a5.36 5.36 0 0 0-1.58-3.816 5.402 5.402 0 0 0-7.63 0h-.001l-3.052 3.053a1.08 1.08 0 1 0 1.526 1.526l3.052-3.052a3.241 3.241 0 0 1 4.579 0c.611.611.948 1.424.948 2.289 0 .864-.337 1.677-.948 2.289l-3.053 3.052a1.08 1.08 0 0 0 1.527 1.526l3.052-3.052a5.36 5.36 0 0 0 1.58-3.815z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.159 18.79a1.076 1.076 0 0 0 1.526 0l6.104-6.105a1.08 1.08 0 1 0-1.526-1.526l-6.104 6.104a1.08 1.08 0 0 0 0 1.526z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkPaperclip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link-paperclip.2eb981214900e31f8ae764ffd63e9fbe.svg";